import React from 'react'
import MemberProfile from '../MemberProfile/MemberProfile'

const MemberProfileRF = () => {

    return (
        <MemberProfile />
    )
}

export default MemberProfileRF